import { ConditionDefinition, ConditionFormatter } from './types';
import {
  BOOLEAN_CONDITION_LABEL_REQUIRE_FALSE,
  BOOLEAN_CONDITION_LABEL_REQUIRE_TRUE,
} from './nba.constants';

export const formatBooleanSummary: ConditionFormatter = (value) => {
  if (value === undefined || value === null) return null;
  return value
    ? BOOLEAN_CONDITION_LABEL_REQUIRE_TRUE
    : BOOLEAN_CONDITION_LABEL_REQUIRE_FALSE;
};

export const formatNctIdListSummary: ConditionFormatter = (value) => {
  if (!Array.isArray(value) || value.length === 0) return null;
  return value.join(', ');
};

export const PREDEFINED_CONDITIONS: ConditionDefinition[] = [
  {
    key: 'sponsored_trial_nct_numbers',
    label: 'Sponsored trial NCT IDs',
    description: 'Specify which sponsored trial NCT IDs affect this action visibility',
    type: 'sponsored_trial_nct_numbers',
    formatSummary: formatNctIdListSummary,
  },
  {
    key: 'sponsored_treatment_nct_numbers',
    label: 'Sponsored treatment NCT IDs',
    description:
      'Specify which sponsored treatment NCT IDs affect this action visibility',
    type: 'sponsored_treatment_nct_numbers',
    formatSummary: formatNctIdListSummary,
  },
  {
    key: 'exclude_sponsored_trial_nct_numbers',
    label: 'Excluded sponsored trial NCT IDs',
    description: 'Specify which sponsored trial NCT IDs should hide this action when present',
    type: 'sponsored_trial_nct_numbers',
    formatSummary: formatNctIdListSummary,
  },
  {
    key: 'exclude_sponsored_treatment_nct_numbers',
    label: 'Excluded sponsored treatment NCT IDs',
    description: 'Specify which sponsored treatment NCT IDs should hide this action when present',
    type: 'sponsored_treatment_nct_numbers',
    formatSummary: formatNctIdListSummary,
  },
  {
    key: 'userHaveSponseredTrialList',
    label: 'User has sponsored trial',
    description: 'Whether the user has at least one sponsored trial in their matching list',
    type: 'boolean',
    formatSummary: formatBooleanSummary,
  },
  {
    key: 'user_has_sponsored_treatments',
    label: 'User has sponsored treatment',
    description: 'Whether the user has at least one sponsored treatment in their matching list',
    type: 'boolean',
    formatSummary: formatBooleanSummary,
  },
  {
    key: 'patient_has_treatment_history',
    label: 'Patient has treatment history',
    description: 'User has any treatments inserted into Q60a',
    type: 'boolean',
    formatSummary: formatBooleanSummary,
  },
  {
    key: 'has_phase_3_trials',
    label: 'Has phase 3 trials',
    description: 'Indicates if phase 3 trials are available.',
    type: 'boolean',
    formatSummary: formatBooleanSummary,
  },
  {
    key: 'has_missing_critical_info',
    label: 'Has missing critical info',
    description: 'User has missing critical information.',
    type: 'boolean',
    formatSummary: formatBooleanSummary,
  },
  {
    key: 'has_targeted_trials',
    label: 'Has targeted trials',
    description: 'Indicates if targeted trials exist.',
    type: 'boolean',
    formatSummary: formatBooleanSummary,
  },
  {
    key: 'has_immunotherapy_trials',
    label: 'Has immunotherapy trials',
    description: 'Based on matched trials to immunotherapy category',
    type: 'boolean',
    formatSummary: formatBooleanSummary,
  },
  {
    key: 'has_location',
    label: 'Has location',
    description: 'User has provided a location.',
    type: 'boolean',
    formatSummary: formatBooleanSummary,
  },
  {
    key: 'trial_within_100_miles',
    label: 'Trial within 100 miles',
    description: 'There is a trial within 100 miles of the user.',
    type: 'boolean',
    formatSummary: formatBooleanSummary,
  },
  {
    key: 'selected_standard_only',
    label: 'Selected standard of care only',
    description: 'User selected standard of care only.',
    type: 'boolean',
    formatSummary: formatBooleanSummary,
  },
  {
    key: 'have_biomarker',
    label: 'Has biomarker',
    description: 'User has a known biomarker.',
    type: 'boolean',
    formatSummary: formatBooleanSummary,
  },
];


